import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/call-center/")({
  beforeLoad: () => {
    throw redirect({ to: "/call-center/monitoring" });
  },
});
